import GetMenu from '@/app_gql/menus/GetMenu.gql';
import { GetData } from '@/app_lib/getData';
import { Menu } from '@/app_lib/types/Menu';

interface GetMenuParams {
  location?: string;
  slug?: string;
  first?: number;
}

export async function getMenu({ location, slug, first = 100 }: GetMenuParams) {
  const data = await GetData.content<Menu>(
    GetMenu,
    { first, location, slug },
    // cache for 6000 seconds (100 minutes) - this was decided in the moment, so feel free to adjust as needed
    { cache: 'force-cache', next: { revalidate: 6000 } },
  );

  // Safe default so callers receive a stable shape and the page won't crash
  const defaultMenuItems = [
    {
      id: '0',
      label: '',
      parentId: null,
      url: '/',
    },
  ];

  if (!(data.success && data.value)) {
    return defaultMenuItems;
  }

  const validatedData = await Menu.safeParseAsync(data.value);

  if (!validatedData.success) {
    return defaultMenuItems;
  }

  // Safely access nested fields and fall back to defaults when missing
  const menuItems = validatedData.data?.menus?.nodes?.[0]?.menuItems?.nodes ?? defaultMenuItems;

  return menuItems;
}
